// Carry Roll AveragingControls — average, filter outliers, variance (8.3–8.5).

import { useStore } from '../../store';
import { mToYd } from '@carry-roll/shared-logic';

export function AveragingControls() {
  const sessions = useStore((s) => s.sessions);
  const activeId = useStore((s) => s.activeSessionId);
  const distanceUnit = useStore((s) => s.distanceUnit);
  const active = sessions.find((s) => s.id === activeId);
  const conv = (m: number) => (distanceUnit === 'yd' ? Math.round(mToYd(m)) : Math.round(m));

  return (
    <div data-testid="averaging-controls">
      <h3 className="subsection-title">
        Averaging
      </h3>
      {!active ? (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Select a session to see averages.
        </p>
      ) : (
        <div className="text-sm">
          <p>Avg carry: {active.avgCarryM != null ? `${conv(active.avgCarryM)} ${distanceUnit}` : '—'}</p>
          <p>Avg total: {active.avgTotalM != null ? `${conv(active.avgTotalM)} ${distanceUnit}` : '—'}</p>
          <p>
            Ball-speed variance:{' '}
            {active.ballSpeedVariance != null ? `${active.ballSpeedVariance.toFixed(2)} (m/s)²` : '—'}
          </p>
          <p className="mt-1" style={{ color: 'var(--color-text-muted)' }}>
            Toggle excluded shots to tighten the average.
          </p>
        </div>
      )}
    </div>
  );
}
